import { render, staticRenderFns } from "./PageSelect.vue?vue&type=template&id=3eec0b45&"
import script from "./PageSelect.vue?vue&type=script&lang=js&"
export * from "./PageSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports